import { useQuery } from "@tanstack/react-query";
import { adminSearchService } from "../../../services/adminSearch";
import { useAdminSearchStore } from "../store/adminSearchStore";

export function useAdminSearchSessions() {
  const { sessionsState } = useAdminSearchStore();
  const { filters: sessionsFilters, pagination } = sessionsState;

  const queryKey = [
    "adminSearchSessions_key",
    {
      sessionName: sessionsFilters.sessionName,
      sessionDate: sessionsFilters.sessionDate,
      page: pagination.page,
      limit: pagination.limit,
    },
  ];

  return useQuery({
    queryKey,
    queryFn: async () => {
      const filters = {};
      if (sessionsFilters.sessionName) {
        filters.sessionName = sessionsFilters.sessionName;
      }
      if (
        sessionsFilters.sessionDate?.from ||
        sessionsFilters.sessionDate?.to
      ) {
        filters.sessionDate = {
          from: sessionsFilters.sessionDate?.from ?? null,
          to: sessionsFilters.sessionDate?.to ?? null,
        };
      }

      const res = await adminSearchService.adminSearchSessions({
        page: pagination.page,
        limit: pagination.limit,
        filters,
      });
      return {
        sessions: res.sessions || [],
        total: res.total || 0,
      };
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
